<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-lg-6 p-sm-0">
        <section class="section pb-sm-0">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-sm-8 text-center mt-0 mt-sm-5">
                <h2>Looking to get in touch?</h2>
                <p class="lead">Send us an email and we will get back to you as soon as possible.</p>
                <base-input
                  class="mt-5"
                  placeholder="Your name"
                  addon-left-icon="ni ni-user-run"
                  v-model="contactForm.name"
                ></base-input>
                <base-input class="mb-3 mt-3">
                  <textarea
                    class="form-control"
                    name="name"
                    rows="4"
                    cols="80"
                    placeholder="Type a message..."
                    v-model="contactForm.message"
                  ></textarea>
                </base-input>
                <a
                  :href="'mailto:sales@arctec.ie?Subject=Website%20Contact%20Form%20Submission: ' + contactForm.name + '&body=' + contactForm.message"
                  rel="noopener"
                  target="_blank"
                  class="btn btn-info btn-block"
                >Send</a>
                <div class="row justify-content-center">
                  <div class="col-12 col-sm-6">
                    <p class="lead">
                      <span class="mr-3">
                        <i class="fa fa-phone"></i>
                      </span>
                      <a href="tel:35318261377">+353 (0)18261377</a>
                    </p>
                  </div>
                  <div class="col-12 col-sm-6">
                    <p class="lead">
                      <span class="mr-3">
                        <i class="fa fa-envelope"></i>
                      </span>
                      <a href="mailto:sales@arcec.ie">sales@arctec.ie</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="col-12 col-lg-6 p-0">
        <section>
          <iframe
            width="100%"
            height="600"
            frameborder="0"
            style="border: 0; border-bottom:1px solid rgba(0,0,0,0.10); margin-bottom: -6px;"
            src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJvQ1quUltZ0gRt0TFDlbeBw4&key=AIzaSyCkV1-FpqZIfbJaXeL9EKe71f0b2KyI0Ao"
            allowfullscreen
          ></iframe>
        </section>
      </div>
    </div>
  </div>
  <!-- <div>
        <section class="section">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-sm-8 text-center mt-0 mt-sm-5">
                      <h2>Looking to get in touch?</h2>
                      <p class="lead">Send us an email and we will get back to you as soon as possible.</p>
                      <base-input
                        class="mt-5"
                        placeholder="Your name"
                        addon-left-icon="ni ni-user-run"
                        v-model="contactForm.name">
                      </base-input>
                      <base-input class="mb-3 mt-3">
                        <textarea
                          class="form-control"
                          name="name"
                          rows="4"
                          cols="80"
                          placeholder="Type a message..."
                          v-model="contactForm.message">
                        </textarea>
                      </base-input>
                      <a :href="'mailto:sales@arctec.ie?Subject=Website%20Contact%20Form%20Submission: ' + contactForm.name + '&body=' + contactForm.message" rel="noopener"
                         target="_blank"
                         class="btn btn-info btn-block">
                          Send
                      </a>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row row-grid justify-content-center text-center">
                    <div class="col-lg-8">
                        <h2>
                          Where to Find Us
                        </h2>
                        <div class="row mt-5">
                          <div class="col-12 col-md-6">
                            <p class="lead">
                              Unit 1, Damastown Way,<br />
                              Damastown Industrial Park,<br />
                              Mulhuddart, Dublin 15.<br />
                            </p>
                          </div>
                          <div class="col-12 col-md-6">
                            <p class="lead">
                              <span class="mr-3"><i class="fa fa-phone"></i></span><a href="tel:35318261377">+353 (0)18261377</a><br />
                              <span class="mr-3"><i class="fa fa-envelope"></i></span><a href="mailto:sales@arcec.ie">sales@arctec.ie</a>
                            </p>
                          </div>
                        </div>

                        <p>

                        </p>
                        <p>

                        </p>
                        <p>

                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section style="width:100%; padding-top: 3em;">
          <iframe width="100%" height="600" frameborder="0" style="border: 0; border-bottom:1px solid rgba(0,0,0,0.10); margin-bottom: -6px;"
src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJvQ1quUltZ0gRt0TFDlbeBw4&key=AIzaSyCkV1-FpqZIfbJaXeL9EKe71f0b2KyI0Ao" allowfullscreen></iframe>
        </section>
  </div>-->
</template>
<script>
export default {
  data() {
    return {
      contactForm: {
        name: null,
        message: null
      }
    };
  }
};
</script>
<style>
</style>
